(() => {
  const inquiryMap = {
    training: 'Course registration or training',
    consulting: 'Security consulting',
    'horse-soldier': 'Horse Soldier Program',
    agency: 'Law enforcement or first responder training',
    partnership: 'Partnership or organization request',
    general: 'General question'
  };

  const setControlValue = (control, value) => {
    if (!control || !value || control.dataset.ossPrefilled === 'true') return;

    const prototype = Object.getPrototypeOf(control);
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor && typeof descriptor.set === 'function') {
      descriptor.set.call(control, value);
    } else {
      control.value = value;
    }

    control.dataset.ossPrefilled = 'true';
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const applyInquiryPrefill = () => {
    const form = document.getElementById('inquiry-form');
    if (!form) return false;

    const params = new URLSearchParams(window.location.search);
    const inquiry = params.get('inquiry');
    const course = params.get('course');

    setControlValue(document.getElementById('InquiryType'), inquiryMap[inquiry]);
    setControlValue(document.getElementById('ServiceCourse'), course);
    return true;
  };

  const start = () => {
    applyInquiryPrefill();
    [100, 350, 900, 1800].forEach((delay) => window.setTimeout(applyInquiryPrefill, delay));

    const observer = new MutationObserver(() => applyInquiryPrefill());
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 5000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('pageshow', applyInquiryPrefill);
})();